import { useMutation } from "react-query";
import { useIvideon } from "./useIvideon";
import { IdTariffIProps } from "../model/schema";

interface MutateOptions {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

interface DataIProps {
  data: IdTariffIProps;
  options?: MutateOptions;
}

export const useDeleteTariff = () => {
  const { deleteTariff } = useIvideon();
  const mutation = useMutation({
    mutationFn: async (props: DataIProps) => {
      const result = await deleteTariff(props.data);
      if (result.data) {
        return;
      } else {
        throw new Error("Не удалось удалить договор");
      }
    },
    onSuccess: (data, { options }) => {
      options?.onSuccess?.();
    },
    onError: (error, { options }) => {
      options?.onError?.(error);
    },
  });
  const remove = (data: IdTariffIProps, options?: MutateOptions) => {
    mutation.mutate({ data, options });
  };
  return { remove };
};
